export const FourOhFour = () => {
    return (
        <div className="flx-col c-al c-jt page-body">
            <h1>Fehler 404</h1>
            <h4 style={{color: "#565656"}}>Seite nicht gefunden!</h4>
        </div>
    )
}